module.exports = __webpack_public_path__ + "img/XMG.e5884643.svg";